import React from "react";
import { Button } from "~/components/ui/button";

interface CoachCardLockProps {
  onClick?: () => void;
}

export const CoachCardLock = ({ onClick }: CoachCardLockProps) => (
  <div className="absolute inset-0 z-20 bg-white/80 backdrop-blur-sm">
    <div className="flex h-full w-full flex-col items-center justify-center gap-4 p-8">
      <Button
        variant="default"
        size="lg"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (onClick) {
            onClick();
          }
        }}
        className="shadow-lg"
      >
        Sign up to reveal
      </Button>
      <p className="text-gray-800 text-sm font-medium text-center">
        Create an account to see all your matches!
      </p>
    </div>
  </div>
);
